import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import deTranslations from "./locales/de.json";
import enTranslations from "./locales/en.json";
import esTranslations from "./locales/es.json";

const resources = {
  de: {
    translation: deTranslations,
  },
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
};

const getBrowserLanguage = (): string => {
  const browserLang = navigator.language.toLowerCase();
  const supportedLanguages = ["de", "es"];

  // Check if browser language starts with any supported language
  for (const lang of supportedLanguages) {
    if (browserLang.startsWith(lang)) {
      return lang;
    }
  }

  // Default to English if not supported
  return "en";
};

// Set HTML title immediately based on detected language
const setInitialTitle = (lang: string) => {
  const titleMap: Record<string, string> = {
    de: deTranslations.meta.title,
    en: enTranslations.meta.title,
    es: esTranslations.meta.title,
  };
  document.title = titleMap[lang] || titleMap.en;
};

const detectedLang = getBrowserLanguage();
setInitialTitle(detectedLang);

i18n.use(initReactI18next).init({
  resources,
  lng: detectedLang,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
